import React, { useRef, useState } from 'react';
// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

import 'swiper/css';


import { Autoplay } from 'swiper/modules';

export default function SliderHomeBanner() {
    return (
        <>
            <Swiper
                spaceBetween={30}
                centeredSlides={true}
                autoplay={{
                    delay: 2500,
                    disableOnInteraction: false,
                }}


                modules={[Autoplay]}
                className="mySwiper"
                style={{overflow:"hidden", marginTop:""}}
            >

              <SwiperSlide>
                    <div className="">
                        <img src="./assets/img/banner_5.png" alt="sylvanply-banne1" />
                    </div>
                </SwiperSlide>
              <SwiperSlide>
                    <div className="">
                        <img src="./assets/img/Physiotherapist_banner.jpg" alt="sylvanply-banne1" />
                    </div>
                </SwiperSlide>

                <SwiperSlide>
                    <div className="">
                        <img src="./assets/img/banner_4.png" alt="sylvanply-banne1" />
                    </div>
                </SwiperSlide>
               
               <SwiperSlide>
                    <div className="">
                        <img src="./assets/img/banner_1.png" alt="sylvanply-banne1" />
                    </div>
                </SwiperSlide>
               
                <SwiperSlide>
                    <div className="">
                        <img src="./assets/img/banner_6.png" alt="sylvanply-banne1" />
                    </div>
                </SwiperSlide>
                {/* <SwiperSlide>
                    <div className="">
                        <img src="./assets/img/banner_3.png" alt="sylvanply-banne1" />
                    </div>
                </SwiperSlide> */}

                

                
                 <SwiperSlide>
                    <div className="">
                        <img src="./assets/img/banner_0.png" alt="sylvanply-banne1" />
                    </div>
                </SwiperSlide>
               
               
               
               
                

            </Swiper>
        </>
    );
}
